import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import LabelSection from 'components/sections/LabelSection';
import ActionBarDetailWrapper from 'components/wrappers/pages/ActionBarDetailWrapper';
import * as actTableManagement from 'actions/tableManagement';
import SwitchField from 'components/Fields/ReduxForm/SwitchField';
import styles from './style.css';

const validate = (values, props) => {
  const errors = {};
  const { groups, groupDetail } = props;
  if (!values.name || values.name.trim() === '') {
    errors.name = 'Please enter a value';
  } else if (!values.name || values.name.length > 25) {
    errors.name = 'You can only enter up to 25 characters';
  }
  let id = null;
  if (groupDetail) {
    id = groupDetail.id;
  }

  if (values.name) {
    if (
      groups.findIndex(
        _group =>
          _group.name.toLowerCase() === values.name.toLowerCase() &&
          id !== _group.id
      ) !== -1
    ) {
      errors.name = 'Duplicate Name';
    }
  }
  return errors;
};

class GroupForm extends React.Component {
  render() {
    const { handleSubmit, isSubmittingForm } = this.props;
    return (
      <form className={styles.wrapper}>
        <div className={styles['field-wrapper']}>
          <div className="row">
            <div className="col-sm-12">
              <LabelSection
                title={
                  this.props.group.id
                    ? 'Edit Table Group'
                    : 'Create New Table Group'
                }
              />
            </div>
          </div>
          <div className="row mb-20px">
            <div className="col-sm-8">
              Table Group Name
              <Field
                component={SettingField}
                name="name"
                className="form-control"
                placeholder="Ex: Floor 1 Smoking Room, Floor 2"
                maxLength="25"
              />
            </div>
            <div className="col-sm-4">
              Status
              <div>
                <Field
                  component={SwitchField}
                  tableGroupStatus
                  name="active"
                  type="checkbox"
                  onText="Active"
                  offText="Inactive"
                />
              </div>
            </div>
          </div>
        </div>
        <ActionBarDetailWrapper>
          <span className="pull-left">
            {this.props.group.id && (
              <button
                className="btn btn-danger"
                onClick={this._onClickDelete}
                type="button"
                disabled={isSubmittingForm}
              >
                <i className="fa fa-trash" />
              </button>
            )}
          </span>
          <span className="pull-right">
            <button
              type="button"
              className={`btn btn-default ${styles['btn-save']}`}
              onClick={this._onClickCancel}
              disabled={isSubmittingForm}
            >
              Cancel
            </button>
            <button
              className={`btn btn-primary ${styles['btn-save']}`}
              onClick={handleSubmit(this._onSubmit)}
              type="button"
              disabled={isSubmittingForm}
            >
              Save
            </button>
          </span>
        </ActionBarDetailWrapper>
      </form>
    );
  }

  _onClickCancel = event => {
    const { dispatch } = this.props;
    dispatch(actTableManagement.onClickCancel());
    event.preventDefault();
    event.stopPropagation();
  };

  _onClickDelete = event => {
    const { dispatch, groupDetail } = this.props;
    dispatch(actTableManagement.deleteGroupRequest(groupDetail));
    event.preventDefault();
    event.stopPropagation();
  };

  _onSubmit = values => {
    this.props.onSubmit({ ...values, action: 'save' });
  };
}

const selector = formValueSelector('table-management-group');

const mapForm = {
  form: 'table-management-group',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

function mapStateToProps(state) {
  const { groups, groupDetail, isSubmittingForm } = state.tableManagement.group;
  return {
    groups,
    groupDetail,
    isSubmittingForm,
    group: { id: selector(state, 'id') },
    data: {
      form: state.form,
    },
  };
}

export default connect(mapStateToProps)(reduxForm(mapForm)(GroupForm));
